/* AOAM packing checklists. Generated 2026-08-05 by Documents\Packing Checklists\build-theme-files.ps1 - edit that source, not this file. */
function refCard(a){
  const parts = a.parts && a.parts.length
    ? a.parts.map(p=>`
        <div class="part">
          ${partArt(p, 160)}
          <b>${p.qty || ''}</b>
          <div class="pl">${p.label}</div>
          ${p.sub ? `<div class="ps">${p.sub}</div>` : ''}
        </div>`).join('')
    : `<div class="part none">
         ${icon('thread')}
         <b></b>
         <div class="pl">No screws, no hex key</div>
         <div class="ps">threads only</div>
       </div>`;
  const hero = a.hero
    ? `<img class="refhero" loading="lazy" alt="${esc(a.name)}" src="${a.hero}${a.hero.indexOf('?')===-1?'?':'&'}width=420">`
    : '';
  return el(`
    <div class="refcard">
      <h3>${esc(a.name)}</h3>
      ${hero}
      <div class="partgrid">${parts}</div>
      ${a.note ? `<div class="note2">${a.note}</div>` : ''}
    </div>`);
}

function buildRef(){
  const wrap = document.getElementById('refwrap');
  wrap.innerHTML = '';
  wrap.appendChild(el('<h2>Adapter / Assembly Contents Reference</h2>'));
  const grid = el('<div class="refgrid"></div>');
  ADAPTERS.forEach(a=>grid.appendChild(refCard(a)));
  wrap.appendChild(grid);
}
buildRef();

let refOpen = false;
document.getElementById('refBtn').onclick = ()=>{
  refOpen = !refOpen;
  document.getElementById('stack').style.display = refOpen ? 'none' : '';
  document.getElementById('refwrap').style.display = refOpen ? '' : 'none';
  document.getElementById('refBtn').textContent = refOpen ? 'Back to Checklists' : 'Adapter Reference';
};

/* ---------- rendering ---------- */
/* Orders are published to snippets/packing-orders.liquid by the 15-minute sweep, so
   both computers see the same list without anyone copying a file. */
const ORDERS_EMBEDDED = (typeof window !== 'undefined' && window.AOAM_PACKING_ORDERS) || {};
function el(html){ const t=document.createElement('template'); t.innerHTML=html.trim(); return t.content.firstElementChild; }
function esc(s){ return String(s==null?'':s).replace(/[&<>]/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;'}[c])); }

/* One tick box per unit, so 2x gets two boxes. Past four they no longer fit
   the column even wrapped, so it collapses to one box and the count. */
function tickBoxes(qty){
  const n = Math.max(1, parseInt(qty, 10) || 1);
  if(n > 4) return `<i></i><span class="xn">&times;${n}</span>`;
  return '<i></i>'.repeat(n);
}

function checklistCard(c){
  const cfg = (c.config||[]).map(row=>`
    <div class="cfgrow">
      <div class="cfglab">${esc(row.label)}</div>
      <div class="cfgopts">${row.opts.map(o=>`<span class="opt"><i></i>${esc(o)}</span>`).join('')}</div>
    </div>`).join('');

  /* LIBRARY ORDER, not price order, since 2026-08-10. Joel: "organize the products so
     that sabers would be next to each other and all the adapters next to each other,
     etc". The items arrays are now grouped by kind - light, tubes, hilts, caps, adapters
     and connectors, holders, blades, fiber, cases - and re-sorting here by price threw
     that away on the web page while the printed slip honoured it, so the two surfaces
     disagreed. `price` stays on each row as the tie-breaker the grouping sorted within. */
  const sorted = c.items;

  /* 2026-10-06 (Claude), Joel picked F1. His rule "a count badge is a column, not part of a
     title": the count is a FILLED badge hard right on the row, anchored to the ROW (a flex child
     outside the title wrapper, margin-left:auto), and the title keeps the whole left. Tick boxes
     stay one per unit, outlined, on the left, one left edge for every row (same as the Veeqo
     slip). Past four units it is one box and the badge carries the number. Nothing prints at
     quantity 1, same as the slip. The old left Qty column is gone; do not bring it back.
     Mockup: Documents\AOAM-Bundles-2026-10-05\packqty. */
  const units = q => { const n = Math.max(1, parseInt(q, 10) || 1); return n > 4 ? 1 : n; };
  const bw = Math.max(1, ...sorted.map(it => units(it.qty))) * 14;   /* .c-box i = 11pt + 1.5pt margin each side */
  const anyMulti = sorted.some(it => (parseInt(it.qty, 10) || 1) > 1);
  const rows = sorted.map(it => {
    const n = Math.max(1, parseInt(it.qty, 10) || 1);
    return `
    <tr><td class="c-line"><div class="c-ln">` +
      `<span class="c-box" style="width:${bw}pt">${'<i></i>'.repeat(units(it.qty))}</span>` +
      `<div class="c-item">${esc(it.name)}${it.chip?`<b class="c-var">${esc(it.chip)}</b>`:''}${it.sub?`<small>${esc(it.sub)}</small>`:''}</div>` +
      (n > 1 ? `<b class="c-qn">&times;${n}</b>` : '') +
    `</div></td></tr>`;
  }).join('');

  const qc = (c.qc||[]).map(q=>`<span class="opt"><i></i>${esc(q)}</span>`).join('');

  return el(`
  <div class="card">
    <div class="chead">
      <div class="l">
        <div class="brand">Ants on a Melon &middot; Packing Checklist</div>
        <div class="kit">${esc(c.name)}</div>
      </div>
    </div>
    ${cfg ? `<div class="cfg">${cfg}</div>` : ''}
    <div class="itemswrap stretch">
    <table class="items v2">
      <colgroup><col></colgroup>
      <thead><tr><th><div class="c-ln"><span class="c-box" style="width:${bw}pt"></span><span class="c-ih">Item</span>${anyMulti ? '<span class="c-qh">Qty</span>' : ''}</div></th></tr></thead>
      <tbody>${rows}${sorted.length < 5 ? '<tr class="filler"><td></td></tr>' : ''}</tbody>
    </table>
    </div>
    <div class="final">
      <div class="qc">${qc}</div>
      <div class="foot">
        <div class="fbox"><span>Packed by</span>&nbsp;</div>
      </div>
      <div class="rev">${esc(REV)}</div>
    </div>
  </div>`);
}

function blankCard(){ return el('<div class="card blank"></div>'); }

/* ---------- sheet assembly ---------- */
let queue = [];

/* A kit with a long parts list gets a whole column of the sheet instead of a
   quarter, so a 39-line kit stays readable. Everything else stays a quarter. */
function isHalf(c){ return c.items.length >= 12; }

/* Pack the queue into sheets, preserving order. A sheet is two columns; a
   column holds either one half card or two quarter cards. */
function packSheets(){
  const sheets = [];
  let cols = [[],[]];
  const flush = ()=>{ if(cols[0].length||cols[1].length) sheets.push(cols); cols = [[],[]]; };

  queue.forEach(card=>{
    const half = isHalf(card);
    let placed = false;
    for(let ci=0; ci<2 && !placed; ci++){
      const col = cols[ci];
      if(half){ if(col.length===0){ col.push(card); placed = true; } }
      else if(col.length<2 && !(col[0] && isHalf(col[0]))){ col.push(card); placed = true; }
    }
    if(!placed){ flush(); cols[0].push(card); }
  });
  flush();
  if(!sheets.length) sheets.push([[],[]]);
  return sheets;
}

function build(){
  const stack = document.getElementById('stack');
  stack.innerHTML = '';
  const guides = document.getElementById('guides').value === 'on';

  packSheets().forEach(cols=>{
    const sheet = el('<div class="sheet"></div>');
    if(!guides) sheet.classList.add('noguides');
    sheet.appendChild(el('<div class="cut v"></div>'));
    /* the crosswise cut only exists over a column that holds two cards */
    if(cols[0].length===2) sheet.appendChild(el('<div class="cut hl"></div>'));
    if(cols[1].length===2) sheet.appendChild(el('<div class="cut hr"></div>'));
    sheet.appendChild(el('<div class="scissor v">&#9986; cut</div>'));
    /* put the crosswise scissors mark on a side that actually gets cut */
    if(cols[0].length===2 || cols[1].length===2){
      const s = el('<div class="scissor h">&#9986; cut</div>');
      if(cols[0].length!==2){ s.style.left='auto'; s.style.right='2px'; }
      sheet.appendChild(s);
    }

    cols.forEach((col, ci)=>{
      if(!col.length){
        const b = blankCard();
        b.style.gridColumn = ci+1; b.style.gridRow = '1 / span 2';
        sheet.appendChild(b); return;
      }
      col.forEach((card, ri)=>{
        const node = checklistCard(card);
        node.style.gridColumn = ci+1;
        if(isHalf(card)){ node.classList.add('half'); node.style.gridRow = '1 / span 2'; }
        else node.style.gridRow = ri+1;
        sheet.appendChild(node);
      });
      if(col.length===1 && !isHalf(col[0])){
        const b = blankCard();
        b.style.gridColumn = ci+1; b.style.gridRow = 2;
        sheet.appendChild(b);
      }
    });
    stack.appendChild(sheet);
  });
  autofit();
}

/* Shrink any card whose list runs long until it fits its quarter of the sheet.
   Nothing is ever allowed to be clipped at the cut line. */
function autofit(){
  document.querySelectorAll('.card').forEach(card=>{
    const wrap = card.querySelector('.itemswrap');
    /* A stretched table always exactly fills its wrapper, so it can never look
       like it overflows. Measure with the stretch off, then put it back. */
    card.classList.add('measuring');
    /* width counts too: a long QC note or an extra tick box used to push
       through the cut line, and a height-only test never saw it */
    const spills = ()=> card.scrollHeight > card.clientHeight ||
                        card.scrollWidth > card.clientWidth + 1 ||
                        (wrap && wrap.scrollHeight > wrap.clientHeight + 1) ||
                        (wrap && wrap.scrollWidth > wrap.clientWidth + 1);
    let k = 1;
    card.style.setProperty('--k', k);
    while(spills() && k > 0.6){
      k = +(k - 0.02).toFixed(2);
      card.style.setProperty('--k', k);
    }
    const bad = spills();
    card.classList.remove('measuring');
    if(bad){
      card.dataset.overflow = 'yes';
      console.warn('Card still overflows at minimum scale:', card.querySelector('.kit')?.textContent);
    }
  });
}

/* ---------- controls ---------- */
/* 2026-08-19 - Joel: "we need to be able to view the items. this page is broken.
   we need a search bar too". The page rendered nothing at all because the card
   library carried an unescaped apostrophe pair, which threw before CARDS existed.
   The search box below filters both menus and lists every order that contains a
   matching item, so a product name finds the orders that need it. */
const sel = document.getElementById('kitSel');
const BASE_CARDS = CARDS.length;

function cardHay(c){
  let s = c.name || '';
  (c.items||[]).forEach(function(i){ s += ' ' + i.name + ' ' + (i.sub||'') + ' ' + (i.chip||''); });
  (c.config||[]).forEach(function(r){ s += ' ' + r.label + ' ' + (r.opts||[]).join(' '); });
  return s.toLowerCase();
}
function term(){ const q = document.getElementById('q'); return q ? q.value.trim().toLowerCase() : ''; }

/* Order cards (index >= BASE_CARDS) are never filtered out - they only exist
   because an order was just loaded, so hiding them would empty the menu. */
function fillKitSel(want){
  const q = term();
  if(want === undefined || want === null) want = sel.value;
  sel.innerHTML = '';
  let first = null;
  for(let i=0;i<CARDS.length;i++){
    if(q && i < BASE_CARDS && cardHay(CARDS[i]).indexOf(q) === -1) continue;
    const o = document.createElement('option');
    o.value = i;
    o.textContent = CARDS[i].name;
    sel.appendChild(o);
    if(first === null) first = i;
  }
  if(!sel.options.length){
    const n = document.createElement('option');
    n.value = ''; n.textContent = 'no card matches';
    sel.appendChild(n);
    return;
  }
  sel.value = String(want);
  if(sel.selectedIndex < 0) sel.value = String(first);
}
fillKitSel(0);

/* Picking a card in the menu is a live preview by default: it swaps the
   sheet to show just that card. Once "Add to sheet" has been used to start
   building a mix, the menu stops auto-replacing so it doesn't blow away
   what's been added; "Clear" goes back to live-preview mode. */
let userBuiltQueue = false;

function copies(){ return Math.max(1, Math.min(200, +document.getElementById('copies').value||1)); }

sel.onchange = ()=>{
  if(userBuiltQueue || sel.value === '') return;
  const c = CARDS[+sel.value];
  queue = [];
  for(let i=0;i<copies();i++) queue.push(c);
  build();
};

document.getElementById('addBtn').onclick = ()=>{
  if(sel.value === '') return;
  const c = CARDS[+sel.value];
  userBuiltQueue = true;
  for(let i=0;i<copies();i++) queue.push(c);
  build();
};
document.getElementById('clearBtn').onclick = ()=>{ queue=[]; userBuiltQueue=false; build(); };
document.getElementById('guides').onchange = build;
document.getElementById('printBtn').onclick = ()=>window.print();

/* ---------- order loading, the Order menu and search ---------- */
const ORDER_KEYS = Object.keys(ORDERS_EMBEDDED).sort().reverse();

function orderLines(k){
  const d = ORDERS_EMBEDDED[k] || {};
  const out = [];
  (d.cards||[]).forEach(function(c){
    (c.items||[]).forEach(function(i){ out.push(i); });
  });
  return out;
}
function orderHay(k){
  let s = k;
  const d = ORDERS_EMBEDDED[k] || {};
  (d.cards||[]).forEach(function(c){ s += ' ' + (c.name||'') + ' ' + (c.note||''); });
  orderLines(k).forEach(function(i){ s += ' ' + i.name + ' ' + (i.sub||'') + ' ' + (i.chip||''); });
  return s.toLowerCase();
}
function orderDay(k){ return String((ORDERS_EMBEDDED[k]||{}).createdAt || '').slice(0,10); }
function orderSummary(k){
  const seen = [];
  orderLines(k).forEach(function(i){
    const label = (i.qty > 1 ? i.qty + 'x ' : '') + i.name + (i.chip ? ' (' + i.chip + ')' : '');
    if(seen.indexOf(label) === -1) seen.push(label);
  });
  return seen.join(' + ') || 'no lines';
}
function orderMatches(k){ const q = term(); return !q || orderHay(k).indexOf(q) !== -1; }

const osel = document.getElementById('orderSel');
function fillOrderSel(){
  if(!osel) return;
  const keep = osel.value;
  /* 2026-08-19 - the search term no longer filters this menu. The search is
     about the included items, not the orders, so filtering the order list by
     it hid orders that were still perfectly pickable. */
  const hits = ORDER_KEYS;
  osel.innerHTML = '';
  const none = document.createElement('option');
  none.value = '';
  none.textContent = 'none';
  osel.appendChild(none);
  hits.forEach(function(k){
    const o = document.createElement('option');
    o.value = k;
    o.textContent = k + '  ' + orderDay(k) + '  -  ' + orderSummary(k);
    osel.appendChild(o);
  });
  osel.value = keep;
  if(osel.selectedIndex < 0) osel.value = '';
}

/* 2026-08-19 - Joel: "fix the search on this. we want to search through these
   whats included items not the website orders." So a search term is matched
   against every included item in the card library - name, sub-note and chip -
   and every matching LINE is listed, saying which checklist it sits on.
   Clicking one previews that checklist. Orders are not searched at all. */
function itemText(i){ return ((i.name||'') + ' ' + (i.sub||'') + ' ' + (i.chip||'')).toLowerCase(); }

function itemHits(q){
  const out = [];
  for(let ci=0; ci<BASE_CARDS && ci<CARDS.length; ci++){
    const c = CARDS[ci];
    const nameHit = (c.name||'').toLowerCase().indexOf(q) !== -1;
    (c.items||[]).forEach(function(it){
      const direct = itemText(it).indexOf(q) !== -1;
      if(direct || nameHit) out.push({ card:ci, item:it });
    });
    /* an option ticked on the card counts as included too, e.g. a pattern or a length */
    (c.config||[]).forEach(function(r){
      const hay = ((r.label||'') + ' ' + (r.opts||[]).join(' ')).toLowerCase();
      if(hay.indexOf(q) !== -1){
        out.push({ card:ci, item:{ qty:'', name:r.label + ': ' + (r.opts||[]).join(', '), sub:'ticked on the card' } });
      }
    });
  }
  return out;
}

function renderHits(){
  const box = document.getElementById('hits');
  if(!box) return;
  const q = term();
  if(!q){ box.innerHTML = ''; box.style.display = 'none'; return; }
  box.style.display = '';
  const hits = itemHits(q);
  if(!hits.length){
    box.innerHTML = '<div class="hitcount">Nothing included on any checklist matches &quot;' + esc(q) + '&quot;</div>';
    return;
  }
  const cards = [];
  hits.forEach(function(h){ if(cards.indexOf(h.card) === -1) cards.push(h.card); });
  const shown = hits.slice(0, 80);
  box.innerHTML =
    '<div class="hitcount">' + hits.length + ' item' + (hits.length === 1 ? '' : 's') +
    ' on ' + cards.length + ' checklist' + (cards.length === 1 ? '' : 's') +
    ' match &quot;' + esc(q) + '&quot;' + (hits.length > shown.length ? ', showing ' + shown.length : '') +
    ' &middot; click one to preview its checklist</div>' +
    '<div class="hitlist">' + shown.map(function(h){
      const c = CARDS[h.card];
      const qty = (h.item.qty === '' || h.item.qty == null) ? '' : h.item.qty + 'x ';
      return '<button type="button" class="hit" data-card="' + h.card + '">' +
             '<b>' + esc(qty + (h.item.name || '')) + (h.item.chip ? ' ' + esc('(' + h.item.chip + ')') : '') + '</b>' +
             '<span>' + esc(c.name || '') + '</span>' +
             (h.item.sub ? '<em>' + esc(h.item.sub) + '</em>' : '') +
             '</button>';
    }).join('') + '</div>';
  Array.prototype.forEach.call(box.querySelectorAll('.hit'), function(b){
    b.onclick = function(){
      const ci = +b.getAttribute('data-card');
      /* an order may have pushed cards past BASE_CARDS - drop back to the
         library so the index the hit carries still points at the same card */
      resetToBase();
      fillKitSel(ci);
      sel.value = String(ci);
      if(osel) osel.value = '';
      userBuiltQueue = false;
      queue = [];
      const c = CARDS[ci];
      for(let i=0;i<copies();i++) queue.push(c);
      build();
    };
  });
}

function runSearch(){ fillKitSel(); fillOrderSel(); renderHits(); }

(function(){
  const q = document.getElementById('q');
  if(!q) return;
  q.oninput = runSearch;
  const clr = document.getElementById('qclear');
  if(clr) clr.onclick = function(){ q.value = ''; runSearch(); q.focus(); };
})();

function orderData(id){
  const key = String(id).replace(/^#/,'').trim();
  if(ORDERS_EMBEDDED[key]) return Promise.resolve(ORDERS_EMBEDDED[key]);
  return Promise.reject(new Error('no such order'));
}

function resetToBase(){
  CARDS.length = BASE_CARDS;
  fillKitSel(0);
}

function loadOrder(id){
  return orderData(id).then(function(data){
    resetToBase();
    queue = [];
    const start = CARDS.length;
    data.cards.forEach(function(c){
      CARDS.push(c);
      queue.push(c);
    });
    fillKitSel(start);
    userBuiltQueue = false;
    build();
  }).catch(function(){
    document.getElementById('stack').innerHTML =
      '<p style="color:#fff;text-align:center;padding:40px">No checklist for order ' + esc(id) +
      ' yet. Orders appear here within 15 minutes of coming in.</p>';
  });
}

fillOrderSel();
if(osel){
  osel.onchange = function(){
    /* "none" used to leave a blank sheet, which reads exactly like the page being
       broken. Go back to a live preview of the card that is selected instead. */
    if(!osel.value){
      resetToBase();
      const c = CARDS[+sel.value] || CARDS[0];
      queue = [c,c,c,c];
      userBuiltQueue = false;
      build();
      return;
    }
    loadOrder(osel.value);
  };
}

/* Optional preset in the URL so a station can bookmark a mix, e.g.
   ?cards=led-staff-kit:3,tube-sku-chart:1
   Default is one full sheet of the LED Staff Kit. */
(function(){
  const params = new URLSearchParams(location.search);

  /* ?order=87313406 prints the checklist for one real order, including any
     custom build made in the Kit Builder (_kb line property) or the Saber Lab
     (_sl line property / Source='Saber Lab'). The JSON is written by
     order-checklist.mjs, which groups builder line items by those tags. */
  const order = params.get('order');
  if(order){
    const key = String(order).replace(/^#/,'').trim();
    if(osel) osel.value = key;
    loadOrder(key);
    return;
  }

  const q = params.get('cards');
  if(q){
    q.split(',').forEach(part=>{
      const [id,n] = part.split(':');
      const card = CARDS.find(c=>c.id===id.trim());
      if(!card) return;
      const count = Math.max(1, Math.min(200, parseInt(n,10)||1));
      for(let i=0;i<count;i++) queue.push(card);
    });
  }
  if(!queue.length) queue = [CARDS[0],CARDS[0],CARDS[0],CARDS[0]];
  build();
})();
